<template>
  <div class="column_chart"></div>
</template>

<script>
import Highcharts from "highcharts/highstock";
export default {
  name: "ColumnChart",
  props: {
    title: {
      required: true,
      default: '',
    },
    yAxisName: {
      required: true,
      default: '',
    },
    xAxisArray: {
      type: Array,
      required: true,
    },
    seriesData: {
      // type: Array,
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    xAxisArray: {
      handler(newValue) {
        if (this.chart) {
          this.chart.update({
            xAxis: {
              categories: newValue,
            },
          });
        }
      }
    },
    seriesData: function (val) {
      // console.log(val);
      if (this.chart) {
        this.initChart();
        this.chart.update({
          series: [{
            type: 'column',
            name: val.name,
            data: val.data
          }],
          tooltip: {
            // head + 每个 point + footer 拼接成完整的 table
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormatter() {
              let prev = '<tr><td style="color: rgb(121, 187, 255);padding:0">' + val.name + ': </td>' +
                  '<td style="padding:0"><b>' + val.data[this.index] + '</b></td>'+
                  '<tr><td style="color: rgb(121, 187, 255);padding:0">占比: </td><td style="padding:0"><b>';
              let next = '%</b></td></tr>';
              return prev + val.percent[this.index] + next;
            },
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
        });
        this.chart.hideLoading();
      }
    },
    title: function (val) {
      if (this.chart) {
        this.chart.update({
          title: {
            text: val,
          }
        });
      }
    },
    yAxisName: function (val) {
      if (this.chart) {
        this.chart.update({
          yAxis: {
            title: {
              text: val,
            }
          }
        });
      }
    },
  },
  mounted() {
    this.initChart();
    this.chart.showLoading();
  },
  methods: {
    initChart(){
      let that = this;
      this.chart = new Highcharts.Chart(this.$el, {
        chart: {
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: {
          text: that.title,
        },
        xAxis: {
          categories: that.xAxisArray,
          crosshair: true
        },
        yAxis: {
          min: 0,
          // max: 100,
          title: {
            text: that.yAxisName,
            style: {
              'font-size': '16px',
            }
          }
        },
        legend: {
          enabled: false,
        },
        tooltip: {},
        series: [{}],
        colors: ['rgb(121, 187, 255)'],
      })
    },
  },
}
</script>

<style scoped>

</style>
